import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { ClipLoader } from 'react-spinners'

// Services
import { accountingPlatformsService } from '../_services'

// helpers
import { history } from '../_helpers'

// Constants
import ROUTES from '../_constants/routes'
import { tenantColors } from '../_constants/colors'
import { notificationsActions } from '../_actions'

// Styled Components
const StyledQuickbooksLoadingPage = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  height: 100%;
  justify-content: center;
  font-size: 1.5rem;

  & > * {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0px;
    }
  }
`

class QuickbooksLoadingPage extends React.Component {
  componentDidMount() {
    const { user, showNotification } = this.props
    accountingPlatformsService.getLatestInvoices(user.business_id, `quickbooks`).then(
      (resp) => {
        window.opener.postMessage({ connected: 'connected', source: 'window.opener' }, '*')
        window.close()
      },
      (error) => {
        history.push(ROUTES.accounting_platforms)
        showNotification({
          type: `error`,
          message: `Sorry, an error occured. Please try again.`,
        })
      }
    )
  }
  render() {
    const { tenant } = this.props
    return (
      <StyledQuickbooksLoadingPage>
        <ClipLoader color={tenantColors[tenant].secondary} loading={true} size={50} />
        <p>Connecting with Quickbooks!</p>
        <p>Pulling all your invoices...</p>
      </StyledQuickbooksLoadingPage>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showNotification: (notification) => {
      dispatch(notificationsActions.showNotification(notification))
    },
  }
}

function mapStateToProps(state) {
  const { user, env } = state
  return {
    user,
    tenant: env.tenant,
  }
}

const connectedQuickbooksLoadingPage = connect(mapStateToProps, mapDispatchToProps)(QuickbooksLoadingPage)
export { connectedQuickbooksLoadingPage as QuickbooksLoadingPage }
